import React from 'react'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { Box, Card, Combobox, LineChart } from '@node-space/ui-components'
import { useCalculateRewards } from 'pages/Rewards/hooks/useCalculateRewards'
import { useChartProps } from 'pages/Rewards/hooks/useChartProps'

const getTimePeriodOptions = (t: TFunction) => [
  { leftText: t('rewards.embeddedCustomers.timePeriod.6Months'), value: '6M' },
  { leftText: t('rewards.embeddedCustomers.timePeriod.12Months'), value: '12M' },
]

export const RewardsEmbeddedEarningsChart = () => {
  const { t } = useTranslation()
  const { rewardsData } = useCalculateRewards(100000, 'USDC')
  const chartProps = useChartProps(rewardsData)

  return (
    <Card variant="static" full>
      <Box flexCol gapY={24}>
        <Box flexCol gap={16} className="xl:flex-row xl:justify-between xl:items-center">
          <h4 className="text-h4 text-foreground-prominent">
            {t('rewards.embeddedCustomers.totalEarnings')}
          </h4>

          <Box className="min-w-[200px]">
            <Combobox
              items={getTimePeriodOptions(t)}
              id="earnings-chart-period"
              label={t('rewards.embeddedCustomers.earningsChartPeriod')}
            />
          </Box>
        </Box>

        <Box className="mt-2">
          <LineChart {...chartProps} />
        </Box>
      </Box>
    </Card>
  )
}
